document.addEventListener('DOMContentLoaded', function () {


  const windowWidth = window.innerWidth;
  console.log(windowWidth);
  if (windowWidth < 750) {
    let box7_swiper = new Swiper('.box7_swiper', {
      slidesPerView: 3,
      centeredSlides: true,
      spaceBetween: '1%',
      preloadImages: false,
      lazy: true,
      loop: true,
      navigation: {
        nextEl: '.box7_swiper_button_next',
        prevEl: '.box7_swiper_button_prev',
      },
    })
    let box11_swiper = new Swiper('.box11_swiper', {
      slidesPerView: 1,
      // centeredSlides: true,
      // spaceBetween: '2%',
      preloadImages: false,
      lazy: true,
      autoplay: {
        delay: 1000,
        pauseOnMouseEnter: true,
      },
      loop: true,
      navigation: {
        nextEl: '.box11_swiper_button_next',
        prevEl: '.box11_swiper_button_prev',
      },
    })
  } else {
    let box7_swiper = new Swiper('.box7_swiper', {
      slidesPerView: 5,
      centeredSlides: true,
      preloadImages: false,
      lazy: true,
      spaceBetween: '1%',
      loop: true,
      navigation: {
        nextEl: '.box7_swiper_button_next',
        prevEl: '.box7_swiper_button_prev',
      },
    })
    let box11_swiper = new Swiper('.box11_swiper', {
      slidesPerView: 4,
      // centeredSlides: true,
      // spaceBetween: '2%',
      preloadImages: false,
      lazy: true,
      autoplay: {
        delay: 1000,
        pauseOnMouseEnter: true,
      },
      loop: true,
      navigation: {
        nextEl: '.box11_swiper_button_next',
        prevEl: '.box11_swiper_button_prev',
      },
    })
  };




});